import { Component } from "react";
import { Link } from "react-router-dom";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";

import adamMarinerImage from "../../images/our-team/adam-mariner.webp";
import alyssaBakerImage from "../../images/our-team/alyssa-baker.webp";
import danielVarillasImage from "../../images/our-team/daniel-varillas.webp";
import duvannyVelezImage from "../../images/our-team/duvanny-velez.webp";
import jasonFairImage from "../../images/our-team/jason-fair.webp";
import joseRodriguezImage from "../../images/our-team/jose-rodriguez.webp";
import kelleyHowardImage from "../../images/our-team/kelley-howard.webp";
import kurtGrevesImage from "../../images/our-team/kurt-greves.webp";
import nassonCarrilloMedinaImage from "../../images/our-team/nasson-carrillo-medina.webp";
import seanBollingerImage from "../../images/our-team/sean-bollinger.webp";
import trippFuscoImage from "../../images/our-team/tripp-fusco.webp";

// Team Content
export const teamMembers = [
  {
    name: "Kelley Howard",
    subtitle: "Partner",
    image: kelleyHowardImage,
    socialMedia: [
      {
        platform: "LinkedIn",
        link: "https://www.linkedin.com/in/kelleyhoward/",
      },
    ],
    bio: [
      "Kelley is focused on Content Development and Strategy. With 30+ years of experience working in the digital marketing space, she has held a position at companies like Cox Interactive Media, Gannett and several startups selling digital media and content marketing.",
      "She has a proven track record in this dynamic sector, earned by working closely with several leading organizations such as The Mayo Clinic, MD Anderson Cancer Center, Pfizer, Banner Health, Johnson & Johnson and Medtronic as well as many companies in the Diagnostic space, like Myriad Genetics, Invitae, Natera, GeneDX, Agendia and Caris Life Sciences.",
      "Over the last 15 years Kelley has been focused on working with companies in Biotechnology and Healthcare. “I love this space and after many years you start to see helpful patterns and understand insights that are extremely valuable to our clients in these spaces.",
      "Kelley and her co-founders launched DigiVid360 in 2015 where the majority of their clients were in the Biotechnology, Life Sciences and MedTech industries. DigiVid360 success and concentrated client list was the catalyst for starting DigiVidBIO a digital marketing firm that is 100% dedicated to the Biotechnology Life Sciences and MedTech spaces.",
    ],
  },
  {
    name: "Jason Fair",
    subtitle: "VP Digital Strategy",
    image: jasonFairImage,
    socialMedia: [
      { platform: "LinkedIn", link: "https://www.linkedin.com/in/jasonfair" },
    ],
    bio: [
      "As DigiVidBIO's VP of Digital Strategy, Jason's role is to help biotech, healthcare and medical clients achieve their business goals using tailor-made video and digital marketing strategies.      ",
      "Using his extensive 20 year experience in omnichannel digital marketing and video strategies, Jason is able to guide clients in reaching their brand and marketing objectives with ever-evolving digital technologies. This includes extensive use of first party data, analytics and conference tactics which allow clients to adjust their digital strategies to drive the best results.",
      "Jason has a passion for  biotech, healthcare and medical digital marketing and has worked across all aspects and areas including: inbound marketing, targeted display, email, conference marketing, social media and programmatic. He is also Google AdWords and HubSpot certified.",
      "Jason has helped main biotech, healthcare and medical organizations of all including: Allergan, Suneva Medical, Agilent Technologies, Medtronic, LabCorp, Tempus Labs, 23andMe, Boston Scientific and miraDry.",
      "In his free time he enjoys spending time with his family, running, biking, skiing, swimming and hiking.",
    ],
  },
  {
    name: "Kurt Greves",
    subtitle: "Partner",
    image: kurtGrevesImage,
    socialMedia: [
      { platform: "LinkedIn", link: "https://www.linkedin.com/in/kurtgreves" },
    ],
    bio: [
      `With a background spanning media, artificial intelligence, biotechnology, and life sciences, Kurt Greves thrives at the intersection of innovation and strategic growth. His experience includes leadership roles at Comedy Central (Viacom) and AMC Networks, where he collaborated with creative teams and helped shape the direction of well-known shows such as “Mad Men,” “Breaking Bad,” “The Walking Dead,” “South Park,” and “The Daily Show with Jon Stewart.”`,
      `Kurt has designed and implemented talent development programs, including initiatives such as “Laugh Riots,” and has worked closely with industry partners like Comcast Spotlight, Time Warner Media, and Cox Media. Along the way, he contributed to brand strategies and campaigns recognized by organizations such as the VAB in New York.`,
      `Expanding beyond television, Kurt founded SecurePathAI and DigiVidAI, focusing on the practical applications of artificial intelligence, while also supporting clients in biotechnology and life sciences through DigiVidBIO and multiple industries through DigiVid360. His work centers on building strong partnerships, supporting sustainable business outcomes, and helping organizations adapt to changing markets.`,
      `Driven by curiosity and a commitment to collaboration, Kurt brings an analytical and solution-oriented approach to every project, whether advising startups or established brands. He believes in empowering teams to reach their best work and enjoys working with people who share a passion for progress and creativity.`,
    ],
  },
  {
    name: "Sean Bollinger",
    subtitle: "Partner",
    image: seanBollingerImage,
    socialMedia: [
      {
        platform: "LinkedIn",
        link: "https://www.linkedin.com/in/seanbollinger",
      },
    ],
    bio: [
      "With a foundation in Marketing, Finance, and Business Management, Sean Bollinger is the organizer and business manager to ensure smooth client delivery, communication and collaboration. He works in the foreground and the background to ensure that client expectations are exceeded.      ",
      "Sean brings talent and experience to underpin DigiVidBIO's growth as a video marketing company. He has extensive Digital Agency experience, specifically helping clients grow their business through the right application of digital tactics and hard data to guide strategic direction. He's particularly skilled at growing client relationships through the thoughtful integration of strategies and tactics which are tied to client success.      ",
      "During his 15-plus years in the digital marketing space, he has worked with several notable small and large brands in various industries including: AAA, American Airlines, US Bank, MasterCard, Microsoft, Hilton, Marriott, Discount Tire, Farmer's Insurance, Banner MD Anderson, Invitae, Illumina, Labcorp, and Natera.      ",
      "Outside the office, Sean Bollinger volunteers for the One-n-Ten organization, contributing his talent and time to youth development and mentoring.      ",
    ],
  },
  {
    name: "Alyssa Baker",
    subtitle: "Senior Producer",
    image: alyssaBakerImage,
    socialMedia: [{ platform: "LinkedIn", link: "http://linkedin.com/in/alyssalbaker" }],
    bio: [
      `Alyssa Baker is a storyteller at heart, blending creativity with strategy to help brands shine in the digital world. With a passion for video and digital content, Alyssa brings ideas to life, whether it's crafting compelling brand stories, orchestrating dynamic on-set productions, or guiding creative teams from concept to launch. Clients value her ability to turn complex visions into clear, engaging videos and digital experiences that connect with audiences and drive results.`,
      `Alyssa believes in making the creative process seamless and enjoyable, using streamlined systems to keep projects on track and communication flowing. She enjoys collaborating with clients and creative teams alike, ensuring every detail, from visuals to messaging, reflects the unique voice of the brand. Outside the studio, Alyssa's enthusiasm for nerd culture, fitness, and vegan cooking influences her passion for engaging young audiences in health and wellness content.`,
      `If you're looking for a creative partner to elevate your next project, Alyssa is ready to help you make an impact through vibrant stories, captivating content, and a personal touch that brings brands to life.`,
    ],
  },
  {
    name: "Adam Mariner",
    subtitle: "Senior Cinematographer & Editor",
    image: adamMarinerImage,
    socialMedia: [
      {
        platform: "LinkedIn",
        link: "https://www.linkedin.com/in/adam-mariner-45154440/",
      },
    ],
    bio: [
      `Adam Mariner serves as the Senior Cinematographer & Editor at DigiVidBIO™, bringing a deep passion for video and film to the life sciences, healthcare, and medtech sectors.`,
      `With extensive experience as the founder of Anchor Productions and a background in creative direction, Adam is known for his ability to understand client goals and translate them into dynamic digital content. He has a formal education from the Art Institute of Phoenix and is renowned for his storytelling skills, delivering impactful video narratives for companies and individuals alike. Adam's unique creative vision and commitment to innovation make him an invaluable member of the DigiVidBIO team, continually elevating the company's marketing solutions in the biotech industry.`,
      `Outside of work, Adam is a devoted husband and father. He enjoys playing soccer and spending time outdoors—whether camping, hunting, or exploring new places. As a passionate documentarian, he travels the world to share compelling stories both inside and outside of healthcare.`,
    ],
  },
  {
    name: "Nasson Carrillo Medina",
    subtitle: "Cinematographer & Editor",
    image: nassonCarrilloMedinaImage,
    socialMedia: [
      // {
      //   platform: "LinkedIn",
      //   link: "https://www.linkedin.com/in/adam-mariner-45154440/",
      // },
    ],
    bio: [
      `Nasson brings a rare blend of creativity, adaptability, and technical skill to every production. Whether he's behind the camera or in the editing suite, he thrives in high-pressure environments and pivots seamlessly to meet the moment.`,
      `On set, Nasson is resourceful and flexible — crafting cinematic visuals that balance bold artistic choices with the practical realities of fast-paced shoots. In post-production, his editing style is influenced by major trends in film and music, while staying deeply attuned to evolving audience behaviors across social media to maximize engagement.`,
      `Outside of work, Nasson is an avid runner and documentarian, traveling the world to tell powerful, authentic stories. He's also a passionate adventurer, often exploring local businesses and new experiences wherever he goes.`,
    ],
  },
  {
    name: "Tripp Fusco",
    subtitle: "Video Producer",
    image: trippFuscoImage,
    socialMedia: [
      { platform: "LinkedIn", link: "http://linkedin.com/in/trippf" },
    ],
    bio: [
      `Tripp Fusco is a video producer who thrives at the intersection of creativity and connection, turning stories into experiences that resonate with audiences. He believes powerful storytelling can spark meaningful change and help subject matter experts, brands, and everyday people bring their stories to life. From strategy and planning through execution and delivery, Tripp guides projects with precision and adaptability. Clients value his calm, solution-oriented approach and his ability to make even the most camera-shy individuals feel confident on camera.`,
      `Tripp believes the production process should feel seamless and collaborative. He uses clear systems and steady communication to keep projects on track while leaving space for creative pivots when needed. His focus on building trust allows him to navigate the inevitable twists and turns of production with ease, ensuring every final product reflects the authenticity and goals of the brand. By blending technical expertise with a personable, steady demeanor, he creates an environment where teams and stories thrive.`,
      `Outside of production, Tripp carries the same passion for creativity into his daily life. He can often be found in local coffee shops writing, reading, or refining new projects, always pursuing opportunities to learn, connect, and create. For Tripp, every day is a chance to bring stories to light—whether through video, conversation, or a fresh perspective waiting to be shared. If you're looking for a creative partner to bring your next project to life, Tripp is ready to help you make it happen.`,
    ],
  },
  {
    name: "Jose Rodriguez",
    subtitle: "Senior Animator",
    image: joseRodriguezImage,
    socialMedia: [
      { platform: "LinkedIn", link: "https://www.linkedin.com/in/joserodriguez9/" },
    ],
    bio: [
      `Jose is a Senior Animator with over 15 years of experience in graphic design, animation, and creative direction. His career spans diverse industries including biotechnology, healthcare, technology, and fashion. Known for his artistic versatility, Jose brings a unique blend of technical expertise and creative flair to every project he leads.`,
      `Throughout his career, Jose has collaborated with a wide range of organizations — from startups and non-profits to globally recognized companies such as Adaptive Biotechnologies, Agilent, Biofidelity, Exact Sciences, Myriad, and Thermo Fisher. His innovative animation strategies have helped biotech and healthcare companies enhance their communication and brand impact, while his creative storytelling has supported non-profits in increasing awareness and donations.`,
      `Jose's passion lies in using technology as a bridge for creativity. He continually adapts to emerging tools, including artificial intelligence, and even designs his own solutions to improve workflow and artistic output. As a leader, he believes in providing clear direction while allowing creative freedom, fostering an environment where teams thrive and ideas flourish.`,
      `Beyond his professional life, Jose is deeply connected to the arts. He enjoys music composition, visual arts, and even tattooing in his spare time. A devoted animal lover, he dreams of one day helping stray animals across the world find loving homes.`,
    ],
  },
  {
    name: "Duvanny Velez",
    subtitle: "Account Executive",
    image: duvannyVelezImage,
    socialMedia: [
      { platform: "LinkedIn", link: "https://www.linkedin.com/in/duvannyvelez/" },
    ],
    bio: [
      `Duvanny is driven by the transformative potential of marketing, especially in the digital and video space, where creative strategy meets measurable impact. Over the years, he has seen firsthand how innovative, well-crafted NPI-targeted campaigns can reshape a Biotech/Life Science company's brand trajectory and open new doors for growth.`,
      `What he finds most rewarding is seeing those results come to life, knowing that our work doesn't just generate revenue but creates meaningful connections and lasting change for the businesses we serve.`,
    ],
  },
  {
    name: "Daniel Varillas",
    subtitle: "Marketing Specialist",
    image: danielVarillasImage,
    socialMedia: [
      { platform: "LinkedIn", link: "https://www.linkedin.com/in/daniel-varillas-48420126b/" },
    ],
    bio: [
      `As a Marketing Specialist, Daniel brings his passion and expertise in artificial intelligence and video production to help Biotech/Life Science companies expand their brand presence and grow their customer base. With a strong background in sales and marketing, he has developed a deep appreciation for how technology and creativity can drive meaningful business outcomes.`,
      `In his role, Daniel partners with leading organizations such as Myriad Genetics, Helix, Natera, Hologic, Illumina, PathAI, and others to craft compelling visual stories and execute targeted advertising strategies that deliver measurable results. Collaborating with a dynamic team of video producers, data analysts, and account managers, He takes pride in advancing the innovation and impact of our agency.`,
      `Daniel is inspired by the opportunity to use cutting-edge technology and powerful storytelling to make a lasting difference in global health and wellness.`,
    ],
  },
];

class Team extends Component {
  render() {
    return (
      <>
        <div className="page-content bg-white">
          <div className="banner-wraper">
            <div
              className="page-banner"
              style={{ backgroundImage: "url(" + bnrImg1 + ")" }}
            >
              <div className="container">
                <div className="page-banner-entry text-center">
                  <h1>Our Team</h1>
                  <nav aria-label="breadcrumb" className="breadcrumb-row">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-home"
                          >
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                            <polyline points="9 22 9 12 15 12 15 22"></polyline>
                          </svg>{" "}
                          Home
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Our Team
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <section className="section-area section-sp1 team-wraper">
            <div className="container">
              <div className="row">
                {teamMembers.map((teamMember, index) => (
                  <div key={index} className="col-lg-4 col-sm-6">
                    <div className="team-member mb-30">
                      <div className="team-media">
                        <img
                          src={teamMember.image}
                          alt={teamMember.name || ""}
                        />
                      </div>
                      <div className="team-info">
                        <div className="team-info-comntent">
                          <h4 className="title">{teamMember.name}</h4>
                          <span className="text-secondary">
                            {teamMember.subtitle}
                          </span>
                        </div>
                        <ul className="social-media mt-3">
                          {teamMember.socialMedia.map((social, index) => (
                            <li key={index}>
                              <a
                                rel="noreferrer"
                                target="_blank"
                                href={social.link}
                              >
                                <i
                                  className={`fab fa-${social.platform.toLowerCase()}`}
                                />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Team;
